import { SortDirection } from '@angular/material/sort';
import { SortDirectionDto } from '../../shared/dto/sort-direction.dto';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import moment from 'moment';

export class QueryOptionsMapper {
  static toSortOrderDto(options: QueryOptions) {
    const direction = options.sort?.direction;
    if (!direction) return null;
    return { sortOrder: this.toSortOrder(direction) };
  }

  static toPaginationDto({ page, size }: QueryOptions) {
    return page && size ? { page, size } : null;
  }

  static toStoresFilterDto(options: QueryOptions) {
    const storeIds = options.filters?.find(
      (f) => f.field === 'storeIds'
    )?.value;
    if (!storeIds) return null;

    const ids = Array.isArray(storeIds) ? storeIds.map(Number) : [+storeIds];
    return { storeIds: ids };
  }

  static toDateFilterDto(options: QueryOptions) {
    return options.dateFilter ? { period: options.dateFilter } : null;
  }

  static toStoreFilterDto(options: QueryOptions) {
    const storeId = options.filters?.find((f) => f.field === 'storeId')?.value;

    return storeId ? { storeId: +storeId } : null;
  }

  static toDynamicPeriodDto({
    fromDate = moment().format('YYYY-MM-DD'),
    toDate,
  }: QueryOptions) {
    return toDate ? { fromDate, toDate } : { fromDate };
  }

  static toSearchFilterDto({ searchQuery }: QueryOptions) {
    return searchQuery ? { searchValue: searchQuery } : {};
  }

  private static toSortOrder(direction: SortDirection) {
    switch (direction) {
      case 'asc':
        return SortDirectionDto.ASC;
      case 'desc':
        return SortDirectionDto.DESC;
      default:
        throw new Error(`Invalid sort direction: ${direction}`);
    }
  }
}
